export const isResetSuccessfulSelector = (state) => state.resetPassword.isResetSuccessful
